import axios from "axios"
import { API_URL } from "../../../config"
import { storage } from "../../../helpers";

export const getDocument = (id) => {
    const token = storage.getToken();
    return axios.get(`${API_URL}/documents/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
}